import prodTemplate from './prod';
import type { AppConfigI } from './example';

const storybook: AppConfigI = {
	...prodTemplate,
	openId: {
		client_id: '',
		authority: '',
		accessTokenExpiringNotificationTime: 1200,
	},
	gaTrackerId: '',
	gtmContainerId: '',
	cartStack: {
		siteId: '',
		trackingScriptUrl: '',
	},
	chatConfig: {
		enabled: false,
		orgId: '',
		deploymentId: '',
		communityURL: '',
		scrt2URL: '',
		messagingScriptURL: '',
		settings: { language: '', chatButtonPosition: '' },
		storageDomain: '',
	},
	algolia: {
		applicationId: '',
		searchOnlyApiKey: '',
	},
	feedback: {
		boardToken: '',
	},
	googleMapsApiKey: 'AIzaSyCp1q6YD7Sqz-XNwB8XV5VCetTr-JcQVMc',
	acceptJs: {
		src: '',
		merchantKeys: {},
		fallbackMerchant: { id: '', key: '' },
	},
};

export default storybook;
